function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M29.7676 25.7061C29.7676 26.1891 29.6468 26.6152 29.4053 26.9844C29.1683 27.3535 28.8402 27.6497 28.4209 27.873C28.8949 28.1055 29.2708 28.4245 29.5488 28.8301C29.8268 29.2311 29.9658 29.7074 29.9658 30.2588C29.9658 31.1475 29.6582 31.8493 29.043 32.3643C28.4323 32.8792 27.5892 33.1367 26.5137 33.1367C25.4336 33.1367 24.5814 32.8792 23.957 32.3643C23.3327 31.8447 23.0205 31.1429 23.0205 30.2588C23.0205 29.7256 23.1572 29.2539 23.4307 28.8438C23.7041 28.4336 24.0915 28.11 24.5928 27.873C24.1689 27.6497 23.8363 27.3535 23.5947 26.9844C23.3532 26.6152 23.2324 26.1891 23.2324 25.7061C23.2324 24.8402 23.5264 24.1566 24.1143 23.6553C24.7021 23.154 25.4951 22.9033 26.4932 22.9033C27.5003 22.9033 28.2979 23.154 28.8857 23.6553C29.4736 24.1566 29.7676 24.8402 29.7676 25.7061ZM27.6553 30.0742C27.6553 29.6641 27.5482 29.3496 27.334 29.1309C27.1243 28.9076 26.8464 28.7959 26.5 28.7959C26.1536 28.7959 25.8734 28.9076 25.6592 29.1309C25.445 29.3496 25.3379 29.6641 25.3379 30.0742C25.3379 30.4707 25.445 30.7852 25.6592 31.0176C25.8779 31.2454 26.1628 31.3594 26.5137 31.3594C26.8555 31.3594 27.1312 31.2454 27.3408 31.0176C27.5505 30.7897 27.6553 30.4753 27.6553 30.0742ZM26.4932 24.6807C26.1833 24.6807 25.9463 24.7832 25.7822 24.9883C25.6227 25.1888 25.543 25.4691 25.543 25.8291C25.543 26.1846 25.625 26.4717 25.7891 26.6904C25.9531 26.9092 26.1947 27.0186 26.5137 27.0186C26.8281 27.0186 27.0628 26.9092 27.2178 26.6904C27.3773 26.4717 27.457 26.1846 27.457 25.8291C27.457 25.4736 27.375 25.1934 27.2109 24.9883C27.0514 24.7832 26.8122 24.6807 26.4932 24.6807Z",
  fill: "black"
});

function SvgCart8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart8);
export default __webpack_public_path__ + "static/media/cart8.82aeb600.svg";
export { ForwardRef as ReactComponent };